import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const subcategoryImporterSelectors = importerSelectors(
  'subcategory.importer',
)

export default subcategoryImporterSelectors
